import * as i0 from '@angular/core';
import { input, computed, output, Component } from '@angular/core';
import { NgxIcon } from '@digipay/ngx-icon';
import { NgxButtonComponent } from '@digipay/ngx-button';
function NgxAppBarComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-button", 8);
    i0.ɵɵlistener("finished", function NgxAppBarComponent_Conditional_3_Template_ngx_button_finished_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.finishRightTimer());
    })("click", function NgxAppBarComponent_Conditional_3_Template_ngx_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.rightButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r1.rightButton().style);
    i0.ɵɵproperty("mode", ctx_r1.rightButton().mode)("size", ctx_r1.rightButton().size)("rightIcon", ctx_r1.rightButtonIcon())("destructive", ctx_r1.rightButton().destructive)("disabled", ctx_r1.rightButton().disabled)("timer", ctx_r1.rightButton().timer);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.rightButton().label, " ");
  }
}
function NgxAppBarComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "ngx-icon", 9);
    i0.ɵɵlistener("click", function NgxAppBarComponent_Conditional_4_Template_ngx_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.rightIconClick());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1.rightIconComputed().name)("type", ctx_r1.rightIconComputed().type);
  }
}
function NgxAppBarComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "ngx-icon", 9);
    i0.ɵɵlistener("click", function NgxAppBarComponent_Conditional_9_Template_ngx_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.leftIconClick());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r1.leftIconComputed().name)("type", ctx_r1.leftIconComputed().type);
  }
}
function NgxAppBarComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-button", 10);
    i0.ɵɵlistener("finished", function NgxAppBarComponent_Conditional_10_Template_ngx_button_finished_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.finishLeftTimer());
    })("click", function NgxAppBarComponent_Conditional_10_Template_ngx_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.leftButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(ctx_r1.leftButton().style);
    i0.ɵɵproperty("mode", ctx_r1.leftButton().mode)("size", ctx_r1.leftButton().size)("leftIcon", ctx_r1.leftButtonIcon())("destructive", ctx_r1.leftButton().destructive)("disabled", ctx_r1.leftButton().disabled)("timer", ctx_r1.leftButton().timer);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.leftButton().label, " ");
  }
}
let NgxAppBarComponent = /*#__PURE__*/(() => {
  class NgxAppBarComponent {
    constructor() {
      this.type = input('default');
      this.title = input();
      this.rightIcon = input();
      this.rightButton = input();
      this.leftIcon = input();
      this.leftButton = input();
      this.rightIconComputed = computed(() => this.getIcon(this.rightIcon()));
      this.leftIconComputed = computed(() => this.getIcon(this.leftIcon()));
      this.rightButtonIcon = computed(() => this.getButtonIcon(this.rightButton()));
      this.leftButtonIcon = computed(() => this.getButtonIcon(this.leftButton()));
      this.onRightButtonClick = output();
      this.onRightIconClick = output();
      this.onLeftButtonClick = output();
      this.onLeftIconClick = output();
      this.onFinishRightTimer = output();
      this.onFinishLeftTimer = output();
    }
    getButtonIcon(button) {
      if (!button?.icon) {
        return null;
      }
      return typeof button.icon === 'string' ? {
        name: button.icon,
        type: 'linear'
      } : button.icon;
    }
    getIcon(icon) {
      if (!icon) {
        return null;
      }
      return typeof icon === 'string' ? {
        name: icon,
        type: 'linear'
      } : icon;
    }
    // Right action click handler
    rightButtonClick() {
      this.onRightButtonClick.emit();
    }
    rightIconClick() {
      this.onRightIconClick.emit();
    }
    // Left action click handler
    leftButtonClick() {
      this.onLeftButtonClick.emit();
    }
    leftIconClick() {
      this.onLeftIconClick.emit();
    }
    finishRightTimer() {
      this.onFinishRightTimer.emit();
    }
    finishLeftTimer() {
      this.onFinishLeftTimer.emit();
    }
    static {
      this.ɵfac = function NgxAppBarComponent_Factory(t) {
        return new (t || NgxAppBarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxAppBarComponent,
        selectors: [["ngx-app-bar"]],
        inputs: {
          type: [i0.ɵɵInputFlags.SignalBased, "type"],
          title: [i0.ɵɵInputFlags.SignalBased, "title"],
          rightIcon: [i0.ɵɵInputFlags.SignalBased, "rightIcon"],
          rightButton: [i0.ɵɵInputFlags.SignalBased, "rightButton"],
          leftIcon: [i0.ɵɵInputFlags.SignalBased, "leftIcon"],
          leftButton: [i0.ɵɵInputFlags.SignalBased, "leftButton"]
        },
        outputs: {
          onRightButtonClick: "onRightButtonClick",
          onRightIconClick: "onRightIconClick",
          onLeftButtonClick: "onLeftButtonClick",
          onLeftIconClick: "onLeftIconClick",
          onFinishRightTimer: "onFinishRightTimer",
          onFinishLeftTimer: "onFinishLeftTimer"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 11,
        vars: 7,
        consts: [[1, "ngx-app-bar", "d-flex", "align-items-start", "flex-column", "px-medium", "py-medium", "gap-micro"], [1, "d-flex", "align-items-center", "justify-content-space-between", "w-100"], [1, "d-flex", "align-items-center", "gap-micro"], [3, "mode", "size", "style", "rightIcon", "destructive", "disabled", "timer"], [1, "onback-shade-30", "cursor-pointer"], [1, "title-position", "onback-shade-30"], [1, "st-6"], [3, "mode", "size", "style", "leftIcon", "destructive", "disabled", "timer"], [3, "finished", "click", "mode", "size", "rightIcon", "destructive", "disabled", "timer"], [3, "click", "name", "type"], [3, "finished", "click", "mode", "size", "leftIcon", "destructive", "disabled", "timer"]],
        template: function NgxAppBarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵtemplate(3, NgxAppBarComponent_Conditional_3_Template, 2, 9, "ngx-button", 3)(4, NgxAppBarComponent_Conditional_4_Template, 2, 2, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 5)(6, "span", 6);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 2);
            i0.ɵɵtemplate(9, NgxAppBarComponent_Conditional_9_Template, 2, 2, "div", 4)(10, NgxAppBarComponent_Conditional_10_Template, 2, 9, "ngx-button", 7);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("surface-glass-high-contrast", ctx.type() === "scrolled");
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(3, !!ctx.rightButton() ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(4, !!ctx.rightIconComputed() ? 4 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.title());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(9, !!ctx.leftIconComputed() ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(10, !!ctx.leftButton() ? 10 : -1);
          }
        },
        dependencies: [NgxIcon, NgxButtonComponent],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}.ngx-app-bar[_ngcontent-%COMP%]{position:relative;direction:rtl}.ngx-app-bar[_ngcontent-%COMP%]   .onback-shade-30[_ngcontent-%COMP%]{color:var(--onback-shade-30)}.ngx-app-bar[_ngcontent-%COMP%]   .title-position[_ngcontent-%COMP%]{position:absolute;left:50%;transform:translate(-50%);min-width:max-content}"]
      });
    }
  }
  return NgxAppBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-app-bar
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxAppBarComponent };
